import {
    addCommentToProject,
    getProjects,
    getScenarios,
    projectSelected,
    projectsReceived,
    scenarioSelected,
    statusesReceived
} from "actions";
import {
    DELETE_PROJECT,
    DeleteProjectAction,
    ADD_COMMENT_TO_PROJECT,
    AddCommentToProjectAction,
    GET_PROJECTS,
    GET_PROJECT_STATUSES,
    POST_NEW_PROJECT,
    PostNewProjectAction,
    ProjectSelectedAction,
    ProjectsReceivedAction,
    StatusesReceivedAction,
    UPDATE_PROJECT,
    UpdateProjectAction
} from "actions/Projects/types";
import axios from "axios";
import { showError } from "components/commonUtilities";
import { showToast } from "components/DesignSystem";
import { GeneratorYieldType } from "interfaces/ActionReducer/GetMethod/GetResponse";
import { PutEffect, put, takeEvery, takeLatest } from "redux-saga/effects";
import { readFileAsBase64 } from "../Utilities/generalUtilities";

function* getProjectsHere(): Generator<
    | Promise<ProjectsReceivedAction["payload"]["data"]>
    | GeneratorYieldType<ProjectsReceivedAction["payload"]>,
    void,
    ProjectsReceivedAction["payload"]["data"]
> {
    try {
        const json = yield axios.get("/api/project/").then((response) => response.data);
        yield put(projectsReceived({ data: json }));
    } catch (e) {
        showError(e);
    }
}
export function* getProjectsSaga() {
    yield takeLatest(GET_PROJECTS, getProjectsHere);
}

function* postNewProject(
    action: PostNewProjectAction
): Generator<
    | Promise<ProjectSelectedAction["payload"]["data"]>
    | Promise<string>
    | GeneratorYieldType<ProjectSelectedAction["payload"]>
    | PutEffect<any>,
    void,
    ProjectSelectedAction["payload"]["data"]
> {
    try {
        const payload = new FormData();
        payload.append("name", action.payload.params.name);
        payload.append("description", action.payload.params.description);
        payload.append("status_id", `${action.payload.params.status_id}`);

        if (action.payload.params.file) {
            const base64File = (yield readFileAsBase64(
                action.payload.params.file
            )) as unknown as string;
            payload.append("file", base64File);
        }

        let json = yield axios
            .post("/api/project/", payload, {
                headers: { "Content-Type": "multipart/form-data;" }
            })
            .then((res) => res.data);

        yield put(getProjects());
        yield put(
            getScenarios({
                params: {
                    fields: "id,name,project_id,workorder_id,created"
                }
            })
        );
        yield put(projectSelected({ data: json }));
        let scenario = json.scenarios[0];
        if (scenario) {
            scenario = {
                ...scenario,
                label: scenario.name,
                value: scenario.id,
                listView: true,
                default: false,
                mapView: true
            };
        }
        yield put(scenarioSelected({ selectedScenario: scenario }));

        if (action.payload.afterProcess) {
            action.payload.afterProcess();
        }
    } catch (e) {
        showError(e);
    }
}

//get all the scenarios after succesful post request
export function* postNewProjectSaga() {
    yield takeLatest(POST_NEW_PROJECT, postNewProject);
}

function* GetProjectStatuses(): Generator<
    Promise<any> | GeneratorYieldType<StatusesReceivedAction["payload"]>,
    void,
    StatusesReceivedAction["payload"]["data"]
> {
    try {
        let json = yield axios.get("/api/project-status/").then((res) => res.data);
        yield put(statusesReceived({ data: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getProjectStatusesSaga() {
    yield takeLatest(GET_PROJECT_STATUSES, GetProjectStatuses);
}

function* DeleteProject(action: DeleteProjectAction) {
    try {
        yield axios.delete(`/api/project/${action.payload.project_id}/`);
        if (action.payload.afterProcess) {
            action.payload.afterProcess();
        }
        yield put(getProjects());
    } catch (error) {
        showError(error);
    }
}

export function* DeleteProjectSaga() {
    yield takeEvery(DELETE_PROJECT, DeleteProject);
}

function* UpdateProject(
    action: UpdateProjectAction
): Generator<Promise<any> | PutEffect<any>, void, any> {
    try {
        const payload = new FormData();

        if (typeof action.payload.params.name === "string") {
            payload.append("name", action.payload.params.name);
        }

        if (typeof action.payload.params.description === "string") {
            payload.append("description", action.payload.params.description);
        }

        if (
            typeof action.payload.params.status_id === "number" &&
            action.payload.params.status_id > 0
        ) {
            payload.append("status_id", `${action.payload.params.status_id}`);
        }

        if (action.payload.params.file === null) {
            payload.append("file", "");
            payload.append("file_name", "");
        } else if (action.payload.params.file) {
            const base64File = (yield readFileAsBase64(
                action.payload.params.file
            )) as unknown as string;
            payload.append("file", base64File);

            if (action.payload.params.file_name) {
                payload.append("file_name", action.payload.params.file_name);
            }
        }

        yield axios.patch(`/api/project/${action.payload.project_id}/`, payload, {
            headers: { "Content-Type": "multipart/form-data;" }
        });
        if (action.payload.afterProcess) {
            action.payload.afterProcess();
        }
        yield put(getProjects());
    } catch (e) {
        showError(e);
    }
}

export function* UpdateProjectSaga() {
    yield takeEvery(UPDATE_PROJECT, UpdateProject);
}

function* addCommentToProjectSagaWorker(action: AddCommentToProjectAction) {
    try {
        const payload = {
            comment: action.payload.params.comment,
            project_id: action.payload.params.project_id,
            ...(action.payload.params.parent_comment_id
                ? { parent_comment_id: action.payload.params.parent_comment_id }
                : {})
        };

        yield axios.post(`/api/project-comments/`, payload).then((response) => {
            return response.data;
        });

        yield put(getProjects());
        showToast("Feedback has been submitted successfully", { type: "success" });
    } catch (error) {
        showError(error);
    }
}

export function* addCommentToProjectSaga() {
    yield takeEvery(ADD_COMMENT_TO_PROJECT, addCommentToProjectSagaWorker);
}
